import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../../css/residency-price/ManageResidencyPrice.css";
import "../../css/Manage.css";
import { toast } from "react-toastify";
import ResidencyPriceApi from "../../api/residencyPriceApi";

const ManageResidencyPrice = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [readonly, setReadonly] = useState(true);

  const [residencyData, setResidencyData] = useState([]);

  const GetResidencyPriceList = async () => {
    try {
      const list = (await ResidencyPriceApi.List()).data.data;

      setResidencyData(list.content);
    } catch (err) {
      switch (err.response?.status) {
        case 401:
          toast(
            <div>
              인증시간이 만료되었습니다. <br /> 다시 로그인해주세요.
            </div>
          );
          sessionStorage.clear();
          navigate("/admin/login");
          break;
        case 500:
          toast(
            `${
              err.response.data.message
                ? err.response.data.message
                : "서버에 문제가 있습니다. 잠시후 다시 시도해주세요."
            }`
          );
          break;
        default:
          break;
      }
    }
  };

  const onSubmit = async () => {
    const data = residencyData.map((v) => ({
      days: v.days,
      price: v.price,
    }));
    await ResidencyPriceApi.Patch(data).then((res) => {
      if (res.status === 200) {
        setReadonly(true);
        toast("변경되었습니다.");
      }
    });
  };

  useEffect(() => {
    GetResidencyPriceList();
  }, [location]);

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table">
        <span>거주권 가격 관리</span>
        <div className="manage-table-container">
          <div className="Manage-residency-search-container">
            <div className="Manage-residency-search-number"></div>
            <div className="Manage-residency-search">
              {readonly && (
                <button
                  className="edit-button"
                  type="button"
                  onClick={() => setReadonly(false)}
                >
                  수정하기
                </button>
              )}
              {!readonly && (
                <article className="button-container">
                  <button
                    className="submit-button filter-color"
                    type="button"
                    onClick={onSubmit}
                  >
                    적용하기
                  </button>
                  <button
                    className="cancle-button"
                    type="button"
                    onClick={() => {
                      setReadonly(true);
                      GetResidencyPriceList();
                    }}
                  >
                    취소
                  </button>
                </article>
              )}
            </div>
          </div>
          <div className="Manage-table manage-table-residency">
            <table>
              <thead>
                <tr>
                  <th>박수</th>
                  <th>가격</th>
                  {/* <th>생성일</th> */}
                </tr>
              </thead>
              <tbody>
                {residencyData.map((residencyItem) => {
                  return (
                    <tr key={residencyItem.id}>
                      <td>{residencyItem.id}</td>
                      <td>
                        {readonly ? (
                          <span>{`${residencyItem.price} 원`}</span>
                        ) : (
                          <input
                            type="text"
                            inputMode="numeric"
                            value={residencyItem.price}
                            maxLength={9}
                            onChange={(e) => {
                              setResidencyData((prev) =>
                                prev.map((item) =>
                                  item.id === residencyItem.id
                                    ? {
                                        ...item,
                                        price: Number(
                                          e.target.value.replace(/[^0-9]/g, "")
                                        ),
                                      }
                                    : item
                                )
                              );
                            }}
                          />
                        )}
                      </td>
                      {/* <td>{createDate}</td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageResidencyPrice;
